import { useEffect } from 'react';

export const useMouseParticles = () => {
  useEffect(() => {
    if (window.innerWidth < 768) return;

    const handleMouseMove = (e) => {
      // Only create particles occasionally
      if (Math.random() > 0.8) return;

      const particle = document.createElement('div');
      const size = Math.random() * 6 + 2;
      
      particle.style.cssText = `
        position: fixed;
        width: ${size}px;
        height: ${size}px;
        background: var(--primary-blue);
        border-radius: 50%;
        pointer-events: none;
        z-index: 9999;
        left: ${e.clientX}px;
        top: ${e.clientY}px;
        opacity: 0.7;
        box-shadow: 0 0 8px var(--primary-blue);
        animation: floatAway 1s ease-out forwards;
      `;

      document.body.appendChild(particle);

      // Remove particle after animation
      setTimeout(() => {
        if (particle.parentNode) {
          particle.parentNode.removeChild(particle);
        }
      }, 1000);
    };

    // Add CSS for animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes floatAway {
        0% {
          transform: translate(0, 0) scale(1);
          opacity: 0.7;
        }
        100% {
          transform: translate(${Math.random() * 40 - 20}px, -20px) scale(0);
          opacity: 0;
        }
      }
      
      @media (prefers-reduced-motion: reduce) {
        [style*="animation: floatAway"] {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.head.removeChild(style);
    };
  }, []);
};